

















































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import DateHandler from '@/shared/utils/date-format';
import EventBus, { Event } from '@/event.bus'
import ScriptFilter from '@/domain/scripts/entity/rule-script-filter.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import RuleScript from '@/domain/scripts/entity/rule-script.entity'
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import RuleScriptService from '@/domain/scripts/service/rule-script.service'
import Response from '@/domain/response.entity';
import Pagination from '@/domain/pagination.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store'
import AuthorityService from '@/domain/security/authority.service';
import FilterComponent from './scripts-filter.component.vue';
import Header from './header.json';
import SimulateModal from './simulation/simule-script-modal.component.vue';

@Component({
  components: {
    FilterComponent, VbPagination, VbTooltipSlot, ModalWarning, SimulateModal,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value.split('T')[0]);
    },
  },
})

export default class RuleDataTable extends Vue {
  showFilter: boolean = false;

  header = Header;

  filter: ScriptFilter = ScriptFilter.of({});

  warningModal: boolean = false;

  simulationKey = 0;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'name|asc',
  });

  ruleList: RuleScript[] = [];

  businessUnitId: string = '';

  modalType = '';

  notApplyTooltipText: string = 'Não é possível remover regras publicadas';

  warningMessage = '';

  selectedRule: RuleScript = RuleScript.of({});

  showSimulateModal: boolean = false;

  simulationRule: RuleScript = RuleScript.of({});

  hasPanelCalculationsAuthority: boolean = false;

  canEdit(rule: RuleScript): boolean {
    return !rule.isApproved() || this.hasPanelCalculationsAuthority;
  }

  openNewScript() {
    this.$emit('newScript');
  }

  simulateRule(rule: RuleScript) {
    this.simulationRule = RuleScript.of(rule);
    this.showSimulateModal = true;
  }

  handleWarningModal(rule: RuleScript, value: string) {
    this.warningModal = true;
    this.selectedRule = rule;
    this.modalType = value;
    if (value === 'approval') {
      this.warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, a regra será imediatamente aprovada e não será mais possivel realizar alterações'
    }
    if (value === 'deletion') {
      this.warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, a regra será imediatamente removida'
    }
  }

  handleConfirm() {
    if (this.modalType === 'deletion') {
      this.deleteRule(this.selectedRule)
    }
    if (this.modalType === 'approval') {
      this.approveRule(this.selectedRule)
    }
    this.closeWarningModal()
  }

  closeSimulationModal(value) {
    this.showSimulateModal = value;
    this.simulationKey += 1;
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Configuration')) {
        this.businessUnitId = businessUnit.id;
        this.pagination.page = 1
        this.findRules(this.filter);
      }
    })
    this.findRules(this.filter);
    AuthorityService.authorities().then((authorities: string[]) => {
      this.hasPanelCalculationsAuthority = authorities.includes('PANEL_CALCULATIONS');
    }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  applyFilter(filter: ScriptFilter) {
    this.$route.params.status = filter.status;
    this.filter = ScriptFilter.of(filter);
    this.pagination.page = 1;
    this.findRules(this.filter);
  }

  findRules(filter: ScriptFilter) {
    if (this.businessUnitId) {
      RuleScriptService.filterRules(this.pagination, this.businessUnitId, filter)
        .then((response: Response) => {
          this.ruleList = RuleScript.ofList(response.content)
          this.pagination.total = response.totalElements;
          this.pagination.pageCount = response.totalPages;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  updateTable(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findRules(this.filter);
  }

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  editTooltipText(isApproved: boolean): string {
    return isApproved ? 'Editar' : this.notApplyTooltipText;
  }

  approvalTooltipText(isApproved: boolean): string {
    return isApproved ? 'Aprovar' : this.notApplyTooltipText;
  }

  deleteTooltipText(isApproved: boolean): string {
    return isApproved ? 'Deletar' : this.notApplyTooltipText;
  }

  approveRule(rule: RuleScript) {
    RuleScriptService.approveRule(this.businessUnitId, rule.id)
      .then((response: any) => {
        VbSnackbarService.showSuccess('Regra aprovada com sucesso');
        rule.approve();
        this.findRules(this.filter);
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  deleteRule(rule: RuleScript) {
    RuleScriptService.deleteRule(this.businessUnitId, rule.id)
      .then((response: any) => {
        VbSnackbarService.showSuccess('Regra removida com sucesso');
        this.findRules(this.filter);
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  closeWarningModal() {
    this.warningModal = false;
  }

  editRule(ruleId: string) {
    this.$emit('editRule', ruleId);
  }

  preview(ruleId: string) {
    this.$emit('preview', ruleId);
  }
}

